import { gql } from 'urql';

export const PAGE_CONTENTS_QUERY = gql`
  query PageContents {
    pageContents {
      pageKey
      fi
      sv
      en
    }
  }
`;

export const PAGE_CONTENT_QUERY = gql`
  query PageContent($pageKey: String!) {
    pageContent(pageKey: $pageKey) {
      pageKey
      fi
      sv
      en
    }
  }
`;

export const SAVE_PAGE_CONTENT_MUTATION = gql`
  mutation SavePageContent($input: PageContentInput!) {
    savePageContent(input: $input) {
      pageKey
      fi
      sv
      en
    }
  }
`;
